"use client";

import { Package } from "lucide-react";
import { useRouter } from "next/navigation";
import { useState } from "react";
import type { InventoryCollection } from "./types";

interface InventoryCollectionProps {
  collection: InventoryCollection;
}

export function InventoryCollectionItem({
  collection,
}: InventoryCollectionProps) {
  const router = useRouter();
  const [imageError, setImageError] = useState(false);

  const handleClick = () => {
    router.push(`/collection/${collection.network}/${collection.address}`);
  };

  const handleImageError = () => {
    setImageError(true);
  };
  const showImage = collection.image && !imageError;

  return (
    <button
      className="flex items-center gap-3 bg-white/5 rounded p-3 hover:bg-white/10 cursor-pointer transition-colors w-full text-left"
      onClick={handleClick}
      type="button"
    >
      <div className="w-10 h-10 rounded flex items-center justify-center flex-shrink-0 overflow-hidden bg-white/10">
        {showImage ? (
          <img
            src={collection.image}
            alt={collection.name}
            className="w-10 h-10 object-contain"
            onError={handleImageError}
          />
        ) : (
          <Package className="w-5 h-5 text-white/60" />
        )}
      </div>
      <div className="flex flex-col justify-center min-w-0 flex-1">
        <span className="text-white text-sm font-medium truncate">
          {collection.name}
        </span>
      </div>
    </button>
  );
}
